/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateYardBlockRowDto } from '../model';
// @ts-ignore
import type { SlotDto } from '../model';
// @ts-ignore
import type { UpdateYardBlockRowDto } from '../model';
// @ts-ignore
import type { YardBlockRowDto } from '../model';
/**
 * YardBlockRowsApi - axios parameter creator
 */
export const YardBlockRowsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateYardBlockRowDto} [createYardBlockRowDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockRowsCreate: async (createYardBlockRowDto?: CreateYardBlockRowDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockRows/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createYardBlockRowDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [yardBlockRowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockRowsDelete: async (yardBlockRowId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockRows/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (yardBlockRowId !== undefined) {
                localVarQueryParameter['yardBlockRowId'] = yardBlockRowId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [yardBlockId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockRowsGet: async (yardBlockId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockRows/Get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (yardBlockId !== undefined) {
                localVarQueryParameter['yardBlockId'] = yardBlockId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockRowsGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockRows/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [yardBlockId] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockRowsIsUnique: async (name?: string, yardBlockId?: string, id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockRows/IsUnique`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (yardBlockId !== undefined) {
                localVarQueryParameter['yardBlockId'] = yardBlockId;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [yardBlockRowId] 
         * @param {boolean} [lockStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockRowsSetLockStatus: async (yardBlockRowId?: string, lockStatus?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockRows/SetLockStatus/lock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (yardBlockRowId !== undefined) {
                localVarQueryParameter['yardBlockRowId'] = yardBlockRowId;
            }

            if (lockStatus !== undefined) {
                localVarQueryParameter['lockStatus'] = lockStatus;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateYardBlockRowDto} [updateYardBlockRowDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockRowsUpdate: async (updateYardBlockRowDto?: UpdateYardBlockRowDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockRows/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateYardBlockRowDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * YardBlockRowsApi - functional programming interface
 */
export const YardBlockRowsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = YardBlockRowsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateYardBlockRowDto} [createYardBlockRowDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockRowsCreate(createYardBlockRowDto?: CreateYardBlockRowDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YardBlockRowDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockRowsCreate(createYardBlockRowDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockRowsApi.yardBlockRowsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [yardBlockRowId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockRowsDelete(yardBlockRowId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockRowsDelete(yardBlockRowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockRowsApi.yardBlockRowsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [yardBlockId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockRowsGet(yardBlockId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YardBlockRowDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockRowsGet(yardBlockId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockRowsApi.yardBlockRowsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockRowsGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YardBlockRowDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockRowsGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockRowsApi.yardBlockRowsGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [yardBlockId] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockRowsIsUnique(name?: string, yardBlockId?: string, id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockRowsIsUnique(name, yardBlockId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockRowsApi.yardBlockRowsIsUnique']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [yardBlockRowId] 
         * @param {boolean} [lockStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockRowsSetLockStatus(yardBlockRowId?: string, lockStatus?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SlotDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockRowsSetLockStatus(yardBlockRowId, lockStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockRowsApi.yardBlockRowsSetLockStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateYardBlockRowDto} [updateYardBlockRowDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockRowsUpdate(updateYardBlockRowDto?: UpdateYardBlockRowDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YardBlockRowDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockRowsUpdate(updateYardBlockRowDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockRowsApi.yardBlockRowsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * YardBlockRowsApi - factory interface
 */
export const YardBlockRowsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = YardBlockRowsApiFp(configuration)
    return {
        /**
         * 
         * @param {YardBlockRowsApiYardBlockRowsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockRowsCreate(requestParameters: YardBlockRowsApiYardBlockRowsCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<YardBlockRowDto> {
            return localVarFp.yardBlockRowsCreate(requestParameters.createYardBlockRowDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockRowsApiYardBlockRowsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockRowsDelete(requestParameters: YardBlockRowsApiYardBlockRowsDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.yardBlockRowsDelete(requestParameters.yardBlockRowId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockRowsApiYardBlockRowsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockRowsGet(requestParameters: YardBlockRowsApiYardBlockRowsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<YardBlockRowDto>> {
            return localVarFp.yardBlockRowsGet(requestParameters.yardBlockId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockRowsGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<YardBlockRowDto>> {
            return localVarFp.yardBlockRowsGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockRowsApiYardBlockRowsIsUniqueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockRowsIsUnique(requestParameters: YardBlockRowsApiYardBlockRowsIsUniqueRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.yardBlockRowsIsUnique(requestParameters.name, requestParameters.yardBlockId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockRowsApiYardBlockRowsSetLockStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockRowsSetLockStatus(requestParameters: YardBlockRowsApiYardBlockRowsSetLockStatusRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<SlotDto>> {
            return localVarFp.yardBlockRowsSetLockStatus(requestParameters.yardBlockRowId, requestParameters.lockStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {YardBlockRowsApiYardBlockRowsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockRowsUpdate(requestParameters: YardBlockRowsApiYardBlockRowsUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<YardBlockRowDto> {
            return localVarFp.yardBlockRowsUpdate(requestParameters.updateYardBlockRowDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for yardBlockRowsCreate operation in YardBlockRowsApi.
 */
export interface YardBlockRowsApiYardBlockRowsCreateRequest {
    readonly createYardBlockRowDto?: CreateYardBlockRowDto
}

/**
 * Request parameters for yardBlockRowsDelete operation in YardBlockRowsApi.
 */
export interface YardBlockRowsApiYardBlockRowsDeleteRequest {
    readonly yardBlockRowId?: string
}

/**
 * Request parameters for yardBlockRowsGet operation in YardBlockRowsApi.
 */
export interface YardBlockRowsApiYardBlockRowsGetRequest {
    readonly yardBlockId?: string
}

/**
 * Request parameters for yardBlockRowsIsUnique operation in YardBlockRowsApi.
 */
export interface YardBlockRowsApiYardBlockRowsIsUniqueRequest {
    readonly name?: string

    readonly yardBlockId?: string

    readonly id?: string
}

/**
 * Request parameters for yardBlockRowsSetLockStatus operation in YardBlockRowsApi.
 */
export interface YardBlockRowsApiYardBlockRowsSetLockStatusRequest {
    readonly yardBlockRowId?: string

    readonly lockStatus?: boolean
}

/**
 * Request parameters for yardBlockRowsUpdate operation in YardBlockRowsApi.
 */
export interface YardBlockRowsApiYardBlockRowsUpdateRequest {
    readonly updateYardBlockRowDto?: UpdateYardBlockRowDto
}

/**
 * YardBlockRowsApi - object-oriented interface
 */
export class YardBlockRowsApi extends BaseAPI {
    /**
     * 
     * @param {YardBlockRowsApiYardBlockRowsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockRowsCreate(requestParameters: YardBlockRowsApiYardBlockRowsCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockRowsApiFp(this.configuration).yardBlockRowsCreate(requestParameters.createYardBlockRowDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockRowsApiYardBlockRowsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockRowsDelete(requestParameters: YardBlockRowsApiYardBlockRowsDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockRowsApiFp(this.configuration).yardBlockRowsDelete(requestParameters.yardBlockRowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockRowsApiYardBlockRowsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockRowsGet(requestParameters: YardBlockRowsApiYardBlockRowsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockRowsApiFp(this.configuration).yardBlockRowsGet(requestParameters.yardBlockId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockRowsGetAll(options?: RawAxiosRequestConfig) {
        return YardBlockRowsApiFp(this.configuration).yardBlockRowsGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockRowsApiYardBlockRowsIsUniqueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockRowsIsUnique(requestParameters: YardBlockRowsApiYardBlockRowsIsUniqueRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockRowsApiFp(this.configuration).yardBlockRowsIsUnique(requestParameters.name, requestParameters.yardBlockId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockRowsApiYardBlockRowsSetLockStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockRowsSetLockStatus(requestParameters: YardBlockRowsApiYardBlockRowsSetLockStatusRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockRowsApiFp(this.configuration).yardBlockRowsSetLockStatus(requestParameters.yardBlockRowId, requestParameters.lockStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {YardBlockRowsApiYardBlockRowsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockRowsUpdate(requestParameters: YardBlockRowsApiYardBlockRowsUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockRowsApiFp(this.configuration).yardBlockRowsUpdate(requestParameters.updateYardBlockRowDto, options).then((request) => request(this.axios, this.basePath));
    }
}

